import Box from '@mui/material/Box';
import { SectionTitle, BodyText } from '../components/SectionPrimitives';

export function Section8(): JSX.Element {
  return (
    <Box sx={{ mb: '24px' }}>
      <SectionTitle>8. Dispute Resolution</SectionTitle>
      <BodyText>
        In the event of a dispute arising out of or in connection with the
        Agreement, the parties agree to first attempt to resolve the matter
        through good-faith negotiation. If the dispute cannot be resolved within
        30 days of written notice from one party to the other, the parties agree
        to consider mediation through a mutually agreed mediator before
        commencing any formal legal proceedings. Nothing in this clause shall
        prevent either party from seeking urgent injunctive or interim relief
        from the courts where necessary.
      </BodyText>
    </Box>
  );
}
